import {obtainColumnCount} from './grid/grid'
import {isChromeOnMac, isMobile, isSafari} from './caps'
import {getHeaderHeight} from './layout-dynamics'

let lastDest
export function scrollToElement({element, edge, duration = 500, forceScrollingMode, offset = 0,
    navbarAdjustment = true, safeAreaAdjustment = true}) {
    const nativeScrolling = isSafari() || isMobile() || isChromeOnMac()
    if (nativeScrolling) duration = 0
    const start = window.scrollY
    const distance = getScrollDistance(element, edge, offset, navbarAdjustment, safeAreaAdjustment)
    const startTime = performance.now()
    lastDest = null
    function scrollAnimation(currentTime) {
        const elapsedTime = currentTime - startTime
        const progress = Math.max(Math.min(elapsedTime / duration, 1), 0)
        const ease = easeOutQuad(progress)
        const dest = parseInt(start + distance * (duration ? ease : 1))
        if (Math.abs(window.scrollY - lastDest) < 3 || lastDest === null) {
            lastDest = dest
            window.scrollTo({top: dest, left: 0, behavior: forceScrollingMode || (nativeScrolling ? 'smooth': 'auto')})
            if (elapsedTime < duration) requestAnimationFrame(scrollAnimation)
        }
    }
    function easeOutQuad(t) {return t * (2 - t)}
    requestAnimationFrame(scrollAnimation)
}
export function getScrollDistance(element, edge, offset = 0, navbarAdjustment, safeAreaAdjustment = true) {
    const computedStyle = window.getComputedStyle(document.documentElement)
    const topInset = safeAreaAdjustment
        ? parseFloat(computedStyle.getPropertyValue('--safe-area-inset-top')) || 0 : 0
    const navbarHeight = getHeaderHeight()
    const extraMargin = window.innerWidth < 600 ? 0 : (navbarAdjustment ? (navbarHeight-2) : 0)
    const columnCount = obtainColumnCount()
    const elementHeight = Math.min(window.innerWidth / columnCount, window.innerWidth > 1920 ? 352 : 352) * 2
    const start = window.scrollY
    const topTarget = element && element.getBoundingClientRect().top + window.scrollY - extraMargin - topInset
    const bottomTarget = element && element.getBoundingClientRect().bottom + window.scrollY - window.innerHeight
        + parseInt(computedStyle.getPropertyValue('--safe-area-inset-bottom').replace('px','') || 0) + extraMargin
    let target =  0
    if (element) {
        if (edge)  target = {'top': topTarget, 'center': (bottomTarget + topTarget) / 2, 'bottom': bottomTarget}[edge]
        else if (elementHeight > window.innerHeight - (navbarAdjustment ? (2 * navbarHeight) : 0)
            || window.innerWidth < 600) target = bottomTarget
        else target = topTarget
    }
    return target - start + offset
}
